import React from 'react'
import HowStartpageWorks from '../how-startpage-works'

const HowStartpageWorksSv = () => {
    return <HowStartpageWorks languageCode="sv" />
}

export default HowStartpageWorksSv
